import { render } from "./Ace.vue?vue&type=template&id=1d7a7b96"
import script from "./Ace.vue?vue&type=script&lang=js"
export * from "./Ace.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__